import { render, staticRenderFns } from "./promiseList.vue?vue&type=template&id=b871bbd2"
import script from "./promiseList.vue?vue&type=script&lang=js"
export * from "./promiseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b871bbd2')) {
      api.createRecord('b871bbd2', component.options)
    } else {
      api.reload('b871bbd2', component.options)
    }
    module.hot.accept("./promiseList.vue?vue&type=template&id=b871bbd2", function () {
      api.rerender('b871bbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/promiseList.vue"
export default component.exports